var map = {
	"./COFFEE_MACHINE_AMENITY.svg": "c818",
	"./DISHWASHER_AMENITY.svg": "24fe",
	"./FRIDGE_AMENITY.svg": "0df5",
	"./HAIRDRYER_AMENITY.svg": "da19",
	"./HEATER_AMENITY.svg": "6afb",
	"./IRON_AMENITY.svg": "0433",
	"./KITCHEN_UTENSIL_AMENITY.svg": "eb36",
	"./MICROWAVE_AMENITY.svg": "6b38",
	"./OVEN_AMENITY.svg": "2621",
	"./STOVE_AMENITY.svg": "c800",
	"./TV_AMENITY.svg": "eb92",
	"./VACUUM_AMENITY.svg": "5411",
	"./WASHER_AMENITY.svg": "40dc",
	"./WIFI_AMENITY.svg": "8f11"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba0e";